import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { InfosUser } from 'app/shared/models/class/auth/infosUser';
import { NewUserCounter } from 'app/shared/models/class/counter/counter';
import { CustomerCounter, CustomerDetails } from 'app/shared/models/class/user/user';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { UsersService } from 'app/shared/services/users/users.service';

@Component({
  selector: 'app-my-personal-information',
  templateUrl: './my-personal-information.component.html',
  styleUrls: ['./my-personal-information.component.scss']
})
export class MyPersonalInformationComponent implements OnInit {
  userConnected: InfosUser;
  updatePersonalInfoForm: UntypedFormGroup;
  user: CustomerDetails;

  constructor(
    private faIconService: FaiconService,
    private authService: AuthService,
    private formBuilder: UntypedFormBuilder,
    private usersService: UsersService,
    private uiService: UiService
  ) { }

  ngOnInit(): void {
    this.initComponent();
    this.initForm();
  }

  onSubmit(): void {
    const user = new NewUserCounter(this.f.firstName.value, this.f.lastName.value, this.f.email.value, this.f.phone.value, this.f.address.value, this.f.city.value, this.f.postalCode.value, this.f.country.value);
    user.userKey = +this.userConnected.sub;

    this.usersService.updateUser(user).subscribe({
      next: () => {
        this.getUserDetails();
        this.uiService.showSnackbar('Vos informations ont été mises à jour');
      }
    });

  }

  getFaIcon(faIcon: string): any {
    return this.faIconService.getFaIcon(faIcon);
  }

  private getUserDetails(): void {
    this.usersService.getUserDetails(+this.userConnected.sub).subscribe({
      next: async user => {
        this.user = await user;
        const { firstName, lastName, phoneNumber, email, address, city, postalCode, country } = user;
        this.f.firstName.setValue(firstName);
        this.f.lastName.setValue(lastName);
        this.f.phone.setValue(phoneNumber);
        this.f.email.setValue(email);
        this.f.address.setValue(address);
        this.f.city.setValue(city);
        this.f.postalCode.setValue(postalCode);
        this.f.country.setValue(country);
      }
    });
  }

  private initComponent(): void {
    this.userConnected = this.authService.getDecodedToken();
    this.getUserDetails();
  }

  get f() {
    return this.updatePersonalInfoForm.controls;
  }

  private initForm(): void {
    this.updatePersonalInfoForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      phone: [''],
      email: [''],
      address: [''],
      city: [''],
      postalCode: [''],
      country: ['']
    });

    this.f.email.disable();
  }

}
